// import React, { useState, useEffect } from 'react';
// import { escudoAncho } from 'UI/assets';
// import { Profile, FormAddProfile } from './components';
// import { useAuth } from 'hooks';
// import { Redirect } from 'react-router-dom';
// import { PremiumInvitationByProfilesModal } from 'UI/modals';

import './styles.scss';

export const SelectProfile = () => {

    // const { loggedUser, getUser, doLogout } = useAuth();
    // const [ showFormAddProfile, setShowFormAddProfile ] = useState(false);
    // const [ showPremiumInvitation, setShowPremiumInvitation ] = useState(false);

    // useEffect(() => localStorage.setItem('profile', ''), []);

    // useEffect(() => getUser(), [getUser]); 


    // const handleAddProfile = () => {
    //     if(loggedUser.isPremium || loggedUser.profiles.length < 1) setShowFormAddProfile(true);
    //     else setShowPremiumInvitation(true);
    // }


    
    return (
        <div>Hola</div>
    );
};

